<template lang="html">
    <div id="page__services-search" class="toolbar-search">
        <z-select
            v-model="filter.active" light
            name="service-filter-active"
            id="service-filter-active"
            v-on:input="onFilter"
        >
            <option selected value=""> Активность (все) </option>
            <option v-bind:value="1"> Активные </option>
            <option v-bind:value="0"> Не активные </option>
        </z-select> 

        <z-select
            v-model="filter.section" light
            name="service-filter-section"
            id="service-filter-section"
            v-on:input="onFilter"
        >
            <option selected value=""> Разделы (все) </option>
            <option value="package"> Тара и упаковка </option>
            <option value="services"> Дополнительные услуги </option> 
        </z-select>
        <z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-bind:disabled="!hasFilter" v-on:click="onReset"></z-icon-button>
    </div>
</template>
<script>
    import ClickOutside from 'vue-click-outside'
    import ZSelect from '@/components/ZSelect';
    import ZIconButton from '@/components/ZIconButton.vue';
    export default {
        components: { ZSelect, ZIconButton },
        directives: {ClickOutside},
        data() {
            return {
                filter: {
                    active: '',
                    section: ''
                },
                filterDefault: {
                    active: '',
                    section: ''
                },
            }
        },
        created() {
            this.resolveQueryFilter();
        },
        computed: {
            hasFilter() {
                return Object.values(this.filter).some(item => !!item);
            },
        },
        methods: {
            /**
             * Подставлене фильтра при перезагрузки
             */
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return;
                this.filter = Object.assign({}, JSON.parse(this.$route.query.filter));
            },
            /**
             * Фильтрация
             */
            onFilter() {
                this.$router.push({
                    name:   this.$route.name,
                    params: this.$route.params,
                    query: {
                        filter: JSON.stringify(this.filter)
                    }
                });
                this.$root.$emit('refresh-table', 'price-services');
            },
            /**
             * Сброс фильтра
             */
            onReset() {
                this.filter = Object.assign({}, this.filterDefault);
                let query = Object.assign({}, this.$route.query);
                delete query.filter;

                this.$router.push({ 
                    name: this.$route.name,
                    params: this.$route.params,
                    query: Object.assign({}, query)
                });
                this.$root.$emit('refresh-table', 'price-services');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ServicesToolbar.vue?35698b8e